<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

  export default {
    name: 'app',
    watch:{
      '$route':function(to,from){
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
      }
    },
    created(){
      this.isTimeOut();
      var _this=this;
      this.getWindowHeight();
      window.onresize=function(){
        _this.getWindowHeight();
      }
      this.$Message.config({
        top: 300,
        duration: 3
      });
      window.onpopstate = () => {
        if (sessionStorage.getItem('allowBack')==0) {
          history.go(1)
        }
      }
/*      document.oncontextmenu=function(evt){
        evt.preventDefault();
      }

      document.onselectstart=function(evt){
        evt.preventDefault();
      };*/
     /* function isMinStatus() {
        var isMin = false;
        if (window.outerWidth != undefined) {
          isMin = window.outerWidth <= 160 && window.outerHeight <= 27;
        }
        else {
          isMin = window.screenTop < -30000 && window.screenLeft < -30000;
        }
        console.log('isMin===',isMin)
        return isMin;
      }
      var time=null;
      time=setInterval(function () {
        if(isMinStatus()){
          console.log('7777')
          clearInterval(time);
        }
      },1000)
      isMinStatus();
      window.onbeforeunload = function(){
        return "必您确定要退出页面吗？";
      }*/



    },
    methods:{
      // 长时间未操作
     throttle(fn, wait) {
        var timer = null;
        var startTime = Date.now();
        return function() {
          var curTime = Date.now();
          var remaining = wait - (curTime - startTime);
          var context = this;
          var args = arguments;
          clearTimeout(timer);
          if (remaining <= 0) {
              fn.apply(context, args);
              startTime = Date.now();
          } else {
              timer = setTimeout(fn, remaining);
          }
        }
      },
      handle() {
        clearInterval(this.timeOut);
        if (this.$route.path == '/a/login'||this.$route.path == '/s/login'||this.$route.path == '/t/login'||this.$route.path == '/') {
          return
        }
        // console.log(this.$route.path,'path---------------------')
        this.timeOut = setInterval(()=>{
          this.$Message.warning('长时间未操作，请重新登录')
          sessionStorage.removeItem('auser')
          sessionStorage.clear()
          this.$router.push({path: '/'})
        },1800000) // 30分钟未操作退出登录1800000
      },
      isTimeOut() {
        document.body.onmouseup = this.throttle(this.handle, 1000);
        document.body.onmousemove = this.throttle(this.handle, 1000);
        document.body.onkeyup  = this.throttle(this.handle, 1000);
        document.body.onclick  = this.throttle(this.handle, 1000);
        document.body.ontouchend  = this.throttle(this.handle, 1000);
        window.addEventListener('resize', this.throttle(this.handle, 1000));
        window.addEventListener('scroll', this.throttle(this.handle, 1000));
      },
      getWindowHeight(){
        var minHeight=window.innerHeight||document.documentElement.clientHeight||document.body.clientHeight||window.screen.availHeight;
        localStorage.setItem('minHeight',minHeight+'px');
        sessionStorage.setItem('bodyH',minHeight);
      }
    }
  }
</script>


<style>
@import "./style/common.css";
@import "./style/all.css";
@import "./style/self_iview.css";
@import "../plugins/ztree/css/zTreeStyle.css";
@font-face {
  font-family: 'Symbol';
  src:url('../static/font/symbol.ttf');
}
@font-face {
  font-family: 'Euclid Math One';
  src:url('../static/font/Euclid_Math_One.ttf');
}

/*@font-face {*/
/*  font-family: 'Microsoft YaHei';*/
/*  src:url('../static/font/msyh.ttf');*/
/*}*/
body{
  /*禁止文字被选中*/
  -moz-user-select: none;
  /*火狐*/
  -webkit-user-select: none;
  /*webkit浏览器*/
  -ms-user-select: none;
  /*IE10*/
  -khtml-user-select: none;
  /*早期浏览器*/
  user-select: none;
}
.ztree li ul.line{ background:url('../plugins/ztree/css/img/line_conn.gif') 0 0 repeat-y;}
.ztree li span.button {line-height:0; margin:0; width:16px; height:16px; display: inline-block; vertical-align:middle;
  border:0 none; cursor: pointer;outline:none;
  background-color:transparent; background-repeat:no-repeat; background-attachment: scroll;
  background-image:url("../plugins/ztree/css/img/zTreeStandard.png"); *background-image:url("../plugins/ztree/css/img/zTreeStandard.gif")}
.ztree li span.button.ico_loading{margin-right:2px; background:url('../plugins/ztree/css/img/loading.gif') no-repeat scroll 0 0 transparent; vertical-align:top; *vertical-align:middle}
span.tmpzTreeMove_arrow {width:16px; height:16px; display: inline-block; padding:0; margin:2px 0 0 1px; border:0 none; position:absolute;
  background-color:transparent; background-repeat:no-repeat; background-attachment: scroll;
  background-position:-110px -80px; background-image:url("../plugins/ztree/css/img/zTreeStandard.png"); *background-image:url('../plugins/ztree/css/img/zTreeStandard.gif')}
.help .ivu-radio-checked .ivu-radio-inner{
  border-color: #2bcd99;
}
.help .ivu-radio-inner:after{
  background-color: #2bcd99;
}
.help .ivu-radio{
  margin-right:8px;
}
.help .ivu-radio-wr{
  margin-right:20px;
}
fieldset, img{
  display: inline-block;
  max-width: 100%;
}
@font-face {
  font-family: 'iconfont';  /* project id 951667 */
  src: url('//at.alicdn.com/t/font_951667_z08ibwk20kb.eot');
  src: url('//at.alicdn.com/t/font_951667_z08ibwk20kb.eot?#iefix') format('embedded-opentype'),
  url('//at.alicdn.com/t/font_951667_z08ibwk20kb.woff') format('woff'),
  url('//at.alicdn.com/t/font_951667_z08ibwk20kb.ttf') format('truetype'),
  url('//at.alicdn.com/t/font_951667_z08ibwk20kb.svg#iconfont') format('svg');
}
	img{
    image-rendering:-moz-crisp-edges;
	image-rendering:-o-crisp-edges;
	image-rendering:-webkit-optimize-contrast;
	image-rendering: crisp-edges;
	-ms-interpolation-mode:nearest-neighbor;
  }
.iconfont {
  font-family: "iconfont" !important;
  font-size: 14px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -webkit-text-stroke-width: 0.2px;
  -moz-osx-font-smoothing: grayscale;
}
/* 改变登录页checkbox选中颜色 */
.ivu-checkbox-checked .ivu-checkbox-inner{
  border-color: #2bcd99 !important;
  background-color: #2bcd99 !important;
}
.ivu-drawer-close .ivu-icon-ios-close{
  color: red !important;
  font-size: 45px !important;
  top: -3px !important;
}
.ivu-tabs-nav-container{
  font-size: 17px !important;
}
/* 省略号 */
.psis{
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.psisW8{
  width: 80%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.ivu-btn-primary{
  background: #2bcd99;
  border-color: #2bcd99;
}
.ivu-btn-primary:hover{
  background: #2bcd99;
  border-color: #2bcd99;
}
/* .el-image-viewer__close{
  background: transparent ;
}
.el-image-viewer__actions{
  background: transparent;
} */
.tis{
  text-align: center !important;
  margin-top: 20px !important;
  font-size: 18px !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue